import {
  AlertDialogFooter as AlertDialogFooterPrimitive,
  Grid,
  type ModalFooterProps
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export function AlertDialogFooter({
  children,
  ...props
}: ModalFooterProps): ReactNode {
  return (
    <AlertDialogFooterPrimitive {...props} px="6" py="0" display="block">
      <Grid
        px="6"
        py="4"
        templateColumns="1fr 1fr"
        gap="2"
        sx={{ '& > *': { width: '100%' } }}
      >
        {children}
      </Grid>
    </AlertDialogFooterPrimitive>
  );
}
